function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getContractTagType, getContractText } from '@/libs/customer';
import { clientContractDeleteApi, salesmanCustomApi, saveSalesmanCustomApi, contractViewApi, contractSubscribeApi, contractAbnormalApi, contractImport } from '@/api/enterprise';
import { configRuleApproveApi } from '@/api/config';
import ExportExcel from '@/components/common/exportExcel';
import importExcel from '@/components/common/importExcel';
export default {
  name: 'FinanceList',
  components: {
    ExportExcel: ExportExcel,
    importExcel: importExcel,
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    editContract: function editContract() {
      return import('./components/editContract');
    },
    addContract: function addContract() {
      return import('./components/addContract');
    },
    transferDialog: function transferDialog() {
      return import('@/views/customer/list/components/transferDialog');
    },
    editCustomer: function editCustomer() {
      return import('@/views/customer/list/components/editCustomer');
    },
    VisibleDialog: function VisibleDialog() {
      return import('@/components/form-common/dialog-transfer');
    },
    editExamine: function editExamine() {
      return import('@/views/user/examine/components/editExamine');
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    },
    types: {
      type: Number,
      default: 1
    },
    custom_type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      salesmanList: [],
      tableItemDialogVisible: false,
      defaultTableItemList: [],
      transferDataList: [],
      visibleTableItemList: [],
      getSalesmanCustom: [],
      tableData: [],
      // 表格的数据
      tableHeaders: [],
      // 表格的表头
      total_price: 0,
      drawer: false,
      fromData: {},
      labelText: '',
      contractFromData: {},
      where: {
        page: 1,
        limit: 15,
        types: this.custom_type
      },
      formInfo: {
        id: ''
      },
      parameterData: {
        contract_id: '',
        customer_id: '',
        invoice_id: '',
        bill_id: ''
      },
      total: 0,
      // expiredShow: true,
      transferData: {},
      ids: [],
      loading: false,
      searchSelect: [],
      searchForm: {
        scope_frame: 'all'
      },
      treeData: [{
        label: '全部',
        value: '',
        group: 1
      }, {
        label: '我关注的',
        value: 'concern',
        group: 1
      }, {
        label: '已签约',
        value: 'signed',
        group: 2
      }, {
        label: '未签约',
        value: 'not_signed',
        group: 2
      }, {
        label: '签约作废',
        value: 'void_signed',
        group: 2
      }, {
        label: '过期合同',
        value: 'expired',
        group: 3
      }, {
        label: '急需续费',
        value: 'urgent_renewal',
        group: 3
      }, {
        label: '费用过期',
        value: 'cost_expired',
        group: 3
      }],
      buildData: [],
      saveName: '',
      exportData: {
        data: [],
        cols: [{
          wpx: 130
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 120
        }, {
          wpx: 130
        }, {
          wpx: 130
        }, {
          wpx: 110
        }, {
          wpx: 110
        }]
      },
      search: [],
      viewSearch: [],
      dropdownList: [{
        label: '移交同事',
        value: 1
      }, {
        label: '导出',
        value: 2
      }, {
        label: '导入',
        value: 3
      }]
    };
  },
  computed: {
    treeDataGroup: function treeDataGroup() {
      var treeData = [];
      for (var i = 0; i < this.treeData.length; i++) {
        if (!i || this.treeData[i].group != this.treeData[i - 1].group) {
          treeData.push({
            id: this.treeData[i].group,
            options: []
          });
        }
        treeData[treeData.length - 1].options.push(this.treeData[i]);
      }
      return treeData;
    }
  },
  created: function created() {
    // this.where.types = this.types
    var query = this.$route.query;
    if (query.id && query.name) {
      this.where.name = query.name;
    }
    this.getTableData('', {
      scope_frame: 'all'
    });
    this.salesmanCustom();
    this.getConfigApprove();
  },
  mounted: function mounted() {
    this.where.types = this.custom_type;
    if (this.custom_type == 5) {
      this.where.scope_frame = 'all';
    } else {
      this.where.scope_frame = 'self';
    }
  },
  methods: {
    // 导出列表数据
    exportContract: function exportContract() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var listField, title, aoaData, obj, key, listData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.total > 1000)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", _this.$message.error('超出限制，最大支持导出1000条数据'));
            case 2:
              listField = _this.transferDataList.filter(function (item) {
                return item.type && !['images', 'file', 'oaWangeditor'].includes(item.type);
              }); // 添加ID项
              listField.unshift({
                name: 'ID',
                field: 'id'
              });
              _this.saveName = '导出合同(' + _this.$moment(new Date()).format('MMDDHHmmss') + ').xlsx';
              title = [];
              listField.map(function (item) {
                title.push(item.name);
              });
              aoaData = [title];
              if (!_this.loading) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              _this.loading = true;
              obj = {
                types: _this.custom_type,
                statistics_type: _this.labelText,
                is_export: 1
              };
              for (key in _this.where) {
                if (_this.where[key]) {
                  obj[key] = _this.where[key];
                }
              }
              obj.page = 0;
              obj.limit = 0;
              if (_this.custom_type === 6) {
                obj.scope_frame = 'self';
              }
              _context.next = 18;
              return contractViewApi(obj);
            case 18:
              listData = _context.sent;
              if (listData.data.list.length > 0) {
                listData.data.list.forEach(function (value) {
                  var arr = [];
                  for (var i = 0; i < listField.length; i++) {
                    arr.push(_this.getFieldValue(listField[i], value[listField[i].field]));
                  }
                  aoaData.push(arr);
                });
                _this.exportData.data = aoaData;
                _this.$refs.exportExcel.exportExcel();
              } else {
                _this.$message.error('暂无数据');
              }
              _this.loading = false;
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getFieldValue: function getFieldValue(field, val) {
      if (field.type === 'checked') {
        return val.map(function (item) {
          return item.name;
        }).join(',');
      } else if (field.field === 'contract_customer') {
        return val ? val.customer_name : '';
      } else if (field.type === 'single') {
        if (Array.isArray(val)) {
          return val.join('/');
        }
        return val || '';
      } else if (field.type === 'radio') {
        for (var key in field.dict) {
          if (parseInt(field.dict[key].value) === parseInt(val)) {
            return field.dict[key].label || '';
          }
        }
      } else if (field.type === 'multiple') {
        var arr = val.map(function (item) {
          return item.join('/');
        });
        if (field.input_type === 'select') {
          if (arr.length === 1) {
            return arr[0] + '#';
          } else {
            return arr.join('#');
          }
        } else {
          return arr.join(',');
        }
      } else if (field.type === 'salesman') {
        return val ? val.name : '';
      } else {
        if (field.field === 'id') {
          return val + '';
        } else {
          return val || '';
        }
      }
    },
    // 标为异常
    markedAbnormal: function markedAbnormal(row) {
      var _this2 = this;
      var text, status;
      text = row.contract_status == 3 ? '正常' : '异常';
      status = row.contract_status == 3 ? 0 : 1;
      this.$modalSure(this.$t("\u60A8\u786E\u5B9A\u8981\u5C06\u6B64\u5408\u540C\u6807\u4E3A".concat(text, "\u5417"))).then(function () {
        contractAbnormalApi(row.id, status);
        _this2.getTableData();
        _this2.salesmanCustom();
      });
    },
    handleBuild: function handleBuild(item, val, type) {
      this.parameterData.customer_id = item.eid;
      this.parameterData.contract_id = item.id;
      this.$refs.editExamine.openBox(val, item.id, type);
    },
    getContractTag: function getContractTag(row) {
      return getContractTagType(row);
    },
    getContractTexts: function getContractTexts(row) {
      return getContractText(row);
    },
    isOk: function isOk() {
      this.where.types = '';
      this.getTableData();
    },
    getConfigApprove: function getConfigApprove() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return configRuleApproveApi(0);
            case 2:
              result = _context2.sent;
              _this3.buildData = result.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    focusEvt: function focusEvt(item) {
      var _this4 = this;
      var status = item.contract_followed == 0 ? 1 : 0;
      contractSubscribeApi(item.id, status).then(function (res) {
        _this4.getTableData();
      });
    },
    // 关闭显示列弹框
    handleCloseTableItem: function handleCloseTableItem() {
      this.tableItemDialogVisible = false;
    },
    handleConfirmVisible: function handleConfirmVisible(array) {
      var _this5 = this;
      var data = {
        select_type: 'list_select',
        data: array
      };
      saveSalesmanCustomApi(this.custom_type, data).then(function (res) {
        _this5.tableItemDialogVisible = false;
        _this5.tableHeaders = [];
        _this5.salesmanCustom();
        _this5.getTableData();
      });
    },
    mapDict: function mapDict(dict) {
      for (var i = 0; i < dict.length; i++) {
        dict[i].name = dict[i].label;
        if (dict[i].children) {
          this.mapDict(dict[i].children);
        }
      }
    },
    salesmanCustom: function salesmanCustom() {
      var _this6 = this;
      salesmanCustomApi(this.custom_type).then(function (res) {
        var search_select_list = res.data.search_select;
        var search_list = res.data.search;
        var search = [];
        var viewSearch = [];
        for (var i = 0; i < search_list.length; i++) {
          if (search_list[i].input_type == 'date') {
            search_list[i].input_type = 'date_picker';
          }
          if (search_list[i].field == 'customer_label') {
            search_list[i].input_type = 'tag';
          }
          if (search_list[i].input_type == 'select') {
            if (search_list[i].field == 'area_cascade') {
              search_list[i].input_type = 'cascader_address';
            } else if (search_list[i].type == 'single') {
              search_list[i].input_type = 'cascader_radio';
            } else if (search_list[i].type == 'multiple') {
              search_list[i].input_type = 'cascader';
            }
          }
          if (search_list[i].dict) {
            _this6.mapDict(search_list[i].dict);
          }
          search_list[i].form_value = search_list[i].input_type;
          search_list[i].field_name_en = search_list[i].field;
          search_list[i].field_name = search_list[i].name;
          search_list[i].types = search_list[i].type;
          search_list[i].type = search_list[i].input_type;
          search_list[i].title = search_list[i].name;
          search_list[i].options = search_list[i].dict || [];
          search_list[i].data_dict = search_list[i].dict || [];
          search_list[i].is_city_show = '';
          if (search_select_list.includes(search_list[i].field)) {
            search.push(search_list[i]);
          } else {
            viewSearch.push(search_list[i]);
          }
        }
        _this6.search = search;
        _this6.viewSearch = viewSearch;
        _this6.transferDataList = res.data.list;
        _this6.defaultTableItemList = res.data.list_select;
        var fieldMap = res.data.list.reduce(function (map, item) {
          map[item.field] = item;
          return map;
        }, {});
        var searchMap = res.data.search.reduce(function (map, item) {
          map[item.field] = item;
          return map;
        }, {});
        // 按 list_select 顺序提取数据
        _this6.searchSelect = res.data.search_select.map(function (field) {
          return searchMap[field];
        }).filter(function (item) {
          return item;
        });
        _this6.tableHeaders = res.data.list_select.map(function (field) {
          return fieldMap[field];
        }).filter(function (item) {
          return item;
        });
        _this6.getSalesmanCustom = res.data;
      });
    },
    customSearchEvt: function customSearchEvt() {
      this.tableItemDialogVisible = true;
    },
    // 添加合同
    addContract: function addContract(row) {
      this.contractFromData = {
        title: row ? '编辑合同' : '添加合同',
        edit: false,
        width: '570px'
      };
      this.$refs.addContract.openBox(row);
    },
    handleNodeClick: function handleNodeClick(data) {
      this.where.page = 1;
      this.where.statistics_type = data.value;
      this.getTableData();
    },
    changeTimeSort: function changeTimeSort(e) {
      switch (e.order) {
        case 'ascending':
          this.where.sort = e.prop + ' asc';
          break;
        case 'descending':
          this.where.sort = e.prop + ' desc';
          break;
        default:
          this.where.sort = '';
      }
      this.confirmData(this.where);
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    getTableData: function getTableData() {
      var _this7 = this;
      if (this.loading) return;
      this.loading = true;
      if (this.custom_type == 6) {
        this.where.scope_frame = 'self';
      }
      contractViewApi(this.where).then(function (res) {
        _this7.tableData = res.data.list;
        _this7.total = res.data.count;
        _this7.total_price = res.data.total_price || 0;
        setTimeout(function () {
          _this7.loading = false;
          _this7.$refs.multipleTable.doLayout();
        }, 300);
      }).catch(function (error) {
        _this7.loading = false;
      });
    },
    // 转移
    handleTransfer: function handleTransfer(type) {
      var _this8 = this;
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (this.ids.length <= 0 && type === 1) {
        this.$message.error(this.$t('customer.placeholder22'));
      } else {
        var ids = [];
        if (type === 1) {
          // 批量
          this.ids.map(function (value) {
            ids.push(value.id);
          });
        } else {
          if (this.ids.length > 0) {
            this.$nextTick(function () {
              for (var i = 0; i < _this8.$refs.multipleTable.length; i++) {
                _this8.$refs.multipleTable[i].clearSelection();
              }
            });
          }
          ids.push(row.id);
        }
        this.transferData = {
          title: type === 1 ? '移交其他同事' : this.$t('customer.transfersettings'),
          width: '520px',
          type: 2,
          ids: ids
        };
        this.$refs.transferDialog.handleOpen();
      }
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this9 = this;
      this.$modalSure(this.$t('customer.placeholder27')).then(function () {
        clientContractDeleteApi(item.id).then(function (res) {
          if (_this9.where.page > 1 && _this9.tableData.length <= 1) {
            _this9.where.page--;
          }
          _this9.getTableData();
        });
      });
    },
    // 打开客户
    handleClient: function handleClient(item) {
      item.eid = item.eid;
      item.cid = item.id;
      this.fromData = {
        title: this.$t('customer.editcustomer'),
        width: '1000px',
        data: item
      };
      this.$refs.editCustomer.tabIndex = '1';
      this.$refs.editCustomer.tabNumber = 1;
      this.$refs.editCustomer.openBox(item.eid);
    },
    // 查看
    handleCheck: function handleCheck(item) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              item.cid = item.id;
              _this10.fromData = {
                title: '查看合同',
                width: '1000px',
                data: item,
                isClient: false,
                name: item.client ? item.client.name : '',
                id: item.client ? item.client.id : '',
                edit: true
              };
              _this10.$refs.editContract.tabIndex = '1';
              _this10.$refs.editContract.tabNumber = 1;
              _this10.$refs.editContract.openBox(item);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          page: 1,
          limit: 15,
          types: this.where.types,
          scope_frame: this.where.types == 5 ? 'all' : 'self'
        };
      } else {
        if (this.custom_type == 5 && data.scope_frame && data.scope_frame.length > 0) {
          data.scope_frame = data.scope_frame[0];
        }
        this.where = _objectSpread(_objectSpread({}, this.where), data);
      }
      this.searchForm = data;
      this.where.page = 1;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.ids = val;
    },
    dropdownFn: function dropdownFn(item) {
      switch (item.value) {
        case 1:
          this.handleTransfer(1);
          break;
        case 2:
          this.exportContract();
          break;
        case 3:
          this.$refs.importExcel.btnClick();
          break;
      }
    },
    importExcelData: function importExcelData(arrRes) {
      var _this11 = this;
      var thead = arrRes[0];
      var data = [];
      for (var i = 1; i < arrRes.length; i++) {
        data.push({});
        for (var j = 0; j < arrRes[i].length; j++) {
          if (!j) {
            arrRes[i][j] = Number(arrRes[i][j]);
          }
          data[data.length - 1][thead[j]] = arrRes[i][j];
        }
      }
      contractImport(this.types, data).then(function (res) {
        _this11.getTableData(_this11.labelText, _this11.searchForm);
      });
    }
  }
};